import { useEffect, useState } from 'react'
import FormRow from '../../FormRow'
import {
  DatePicker,
  Field,
  Select
} from '../../../../react-final-form-wrappers'
import useEffectAsync from '../../../../hooks/useEffectAsync'
import { client } from '../../../../client'
import { FormSpy, useField, useForm } from 'react-final-form'
import AsyncSelect from 'react-select/async'
import Hidden from '@material-ui/core/Hidden'
import TextField from '@material-ui/core/TextField'
import IconButton from '@material-ui/core/IconButton'
import HelpOutline from '@material-ui/icons/HelpOutline'
import Tooltip from '@material-ui/core/Tooltip'
import Typography from '@material-ui/core/Typography'
import Link from '@material-ui/core/Link'
import { useTranslation } from 'react-i18next'
import { FilesSection } from '../FilesSection'
import { sentryDebugLog } from '../../../../utils/sentryDebugLog'
import Alert from '@material-ui/lab/Alert'

const debug = (message: string) => sentryDebugLog(message, 'ReferrerSection')
const ReferrerSection = (props: any) => {
  const { t } = useTranslation('referrerSection')
  const { t: tInvoice } = useTranslation('invoiceSection')
  const form = useForm()

  const [referrerName, setReferrerName] = useState('')
  const [selfReferrer, setSelfReferrer] = useState(false)
  const {
    input: { value: referrerAgb }
  } = useField('referrerAgb')
  const {
    input: { value: programId }
  } = useField('id')

  // no idea if it does something, let's fix it some other time
  useEffectAsync(async () => {
    const name = referrerAgb ? handleReferrerAgbChange(referrerAgb) : ''
    // @ts-ignore
    setReferrerName(name)
  }, [])

  const handleReferrerAgbChange = async (agb: string) => {
    if (!agb || agb.length !== 8) {
      setReferrerName('')
      if (form?.mutators?.setValue) form.mutators.setValue('referrerDetailsValid', false)
      return
    }
    const details = await client.findPractitionerByAgb(agb)
    if (Object.keys(details).length === 0) {
      setReferrerName('')
      if (form?.mutators?.setValue) form.mutators.setValue('referrerDetailsValid', false)
    }
    const { Voorletters, Tussenvoegsel, Achternaam } = details
    const name = [Voorletters, Tussenvoegsel, Achternaam].join(' ')
    setReferrerName(name)
    if (form?.mutators?.setValue)
      form.mutators.setValue('referrerDetailsValid', !!name && name.trim().length > 0)
  }

  // Cross-field validation: warn when referral date is after start date
  const referralDate: string | undefined = useField('referralDate').input.value
  const startDate: string | undefined = useField('startDate').input.value

  const isReferralAfterStart = (() => {
    if (!referralDate || !startDate) return false
    const r = new Date(referralDate)
    r.setHours(0, 0, 0, 0)
    const s = new Date(startDate)
    s.setHours(0, 0, 0, 0)
    return r > s
  })()

  return (
    <>
      <FormSpy
        subscription={{ values: true }}
        render={({ values }) => {
          useEffect(() => {
            setSelfReferrer(
              values.referrerType ? values.referrerType.id === 6 : false
            )
          }, [values.referrerType])

          return <></>
        }}
      />
      {!selfReferrer && (
        <FormRow>
          <Field
            style={{ width: 300 }}
            name="referralDate"
            label={t('referralDate')}
            component={DatePicker}
          />
        </FormRow>
      )}

      {!selfReferrer && isReferralAfterStart && (
        <Alert severity="warning" style={{ marginTop: 8 }}>
          {tInvoice('referralDateAfterStartDate')}
        </Alert>
      )}

      <FormRow>
        <Select
          style={{ width: 300 }}
          label={t('referenceType')}
          getOptions={async () => client.getReferrerTypeOptions()}
          getOptionLabel={(i: any) => `${i.code}: ${i.description}`}
          getOptionValue={(i: any) => i.id}
          name="referrerType.id"
        />
      </FormRow>

      {!selfReferrer && (
        <div>
          <Field
            style={{ width: 300 }}
            name="referrerAgb"
            render={({ input: { onChange, ...restInput }, meta }: any) => (
              <TextField
                {...restInput}
                label={t('agbCode')}
                onChange={(event) => {
                  handleReferrerAgbChange(event.target.value)
                  onChange(event)
                }}
              />
            )}
          />
          <TextField
            disabled
            style={{ marginLeft: 20 }}
            label={t('referrerName')}
            value={referrerName}
          />
          <Tooltip
            interactive
            title={
              <Link
                target="_blank"
                href="https://www.vektis.nl/agb-register/zoeken"
                color="inherit"
                style={{ textDecoration: 'none' }}
              >
                <Typography color="inherit">{t('searchRegister')}</Typography>
                <Typography variant="body2">{t('registerInfo')}</Typography>
              </Link>
            }
            placement="right-start"
          >
            <IconButton>
              <HelpOutline fontSize="small" color="primary" />
            </IconButton>
          </Tooltip>
        </div>
      )}

      <Hidden xlDown>
        <FormRow>
          <div style={{ width: 300 }}>
            <Field
              name="referrer"
              render={({ input, meta }: any) => (
                <AsyncSelect
                  {...input}
                  style={{ width: '100%' }}
                  cacheOptions
                  defaultOptions
                  label={t('referrer')}
                  loadOptions={(value) =>
                    value.length >= 3
                      ? client.searchReferrers(value)
                      : Promise.resolve([])
                  }
                  getOptionLabel={(i: any) => i.name}
                  getOptionValue={(i: any) => i.id}
                />
              )}
            />
          </div>
        </FormRow>
      </Hidden>

      {!selfReferrer && (
        <FormRow>
          <FilesSection
            uploadedFileType={'referralLetter'}
            typesToShow={['referralLetter']}
          />
        </FormRow>
      )}
    </>
  )
}

export default ReferrerSection
